const getters = {
    segments: (state) => state.segments,
    customers: (state) => state.customers,
    loading: state => state.loading
};

export default getters;